<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Carritos Abandonados
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Carrito
            div
                v-flex(xs12, sm12, md12 v-if='info && info.carrito')
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md4, sm4 v-for='item in info.carrito')
                            v-card(style='border-radius:10px;')
                                v-card-title(style='height:200px;')
                                    img(:src='ruta + item.imagen[0].url' style="height:auto;width:100%;object-fit:contain;" v-if='item.imagen && item.imagen[0] && item.imagen[0].url')
                                    img(src='../assets/image.png' style="height:auto;width:100%;object-fit:contain;" v-if='!item.imagen || !item.imagen[0] || !item.imagen[0].url')
                                div(style='width:100%;')
                                    div(style='height:1px;background: #c8c7c7;;width:100%;')
                                v-card-actions(style='display: flex;flex-direction: column;')
                                    span(style='font-size:15px;font-weight:500;text-align:center;') {{item.co_art}}
                                    span(style='font-size:15px;font-weight:500;text-align:center;') {{item.nombre}}
                                    span(style='font-size:15px;font-weight:500;text-align:center;') Cantidad: {{item.cantidad}}
                                    span(style='font-size:15px;font-weight:500;text-align:center;') {{item.fecha | moment('DD/MM/YYYY')}}
                        v-flex(xs12)
                            div
                              v-flex(xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-flex(xs12)
      v-card(flat='')
        v-flex(xs12)
          div(style="margin-top:20px")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6)
                  v-text-field(v-model='search2', append-icon='search', label='Buscar' style='width:100%;')
          v-layout(align-start='', justify-start='', row='', fill-height='')
            v-flex(xs12 style='margin-top: 5px;')
              v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                  v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                      span.white--text Lista de Carritos Abandonados
              v-data-table.elevation-1(:headers='headers', :items="clientes", :search='search2', style="margin-top: 5px;")
                template(slot='items', slot-scope='props')
                  td {{ props.item.co_cli }}
                  td {{ props.item.cli_des }}
                  td {{ props.item.carrito.length }}
                  td.justify-start.layout.px-0
                    v-btn.mx-0(icon, style='margin-top: -7px;' @click='abrir(props.item)')
                      v-icon(color='teal') visibility
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mCarrito",
  components: {},
  data: () => ({
    ruta: server + ":" + port,
    search2: "",
    info: null,
    dialog: false,
    clientes: [],
    ruta: server + ":" + port,
    headers: [
      { text: "Codigo", value: "co_cli" },
      { text: "Cliente", value: "cli_des" },
      { text: "Artículos", value: "carrito" },
      { text: "Acciones" },
    ],
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webamairca.permisos.length; i++) {
        if (this.$store.state.webamairca.permisos[i].ruta === "Carrito") {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    close() {
        this.info = null
        this.dialog = false
    },
    abrir(item) {
        this.info = item
        this.dialog = true
    },
    initialize() {
      Api.get("cliente/carrito").then(res => {
        this.clientes = res.data;
      });
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
